var React = require('react');

function ArrowRightBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-2.00272e-05 0.5H3.14929L6.81079 7.99834L3.14929 15.5H-2.00272e-05L3.66148 7.99834L-2.00272e-05 0.5Z","fill":"black"}));
}

ArrowRightBlack.defaultProps = {"width":"7","height":"16","viewBox":"0 0 7 16","fill":"none"};

module.exports = ArrowRightBlack;

ArrowRightBlack.default = ArrowRightBlack;
